import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class VerticalLayoutAlign extends BaseOption {
  static userInterfaceComponent = {
    label: "Align",
    component: inspectorTools.RADIO_BAR,
    iconSize: 24,
    props: {
      options: [
        {
          icon: "align-left",
          value: "left",
        },
        {
          icon: "align-center",
          value: "center",
        },
        {
          icon: "align-right",
          value: "right",
        },
      ],
    },
  };

  static defaultValue = "left";

  static convertConfigValueToCompiledValue(configValue) {
    if (typeof configValue === "string") {
      return configValue;
    }
    if (configValue && configValue.value) {
      return configValue.value;
    }
  }
}
